import { render, staticRenderFns } from "./SEOContent.vue?vue&type=template&id=70b16a55&"
import script from "./SEOContent.vue?vue&type=script&lang=js&"
export * from "./SEOContent.vue?vue&type=script&lang=js&"
import style0 from "./SEOContent.vue?vue&type=style&index=0&id=70b16a55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
